var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ConstructionTask, ConstructionTaskOtherField, KtsConstructionTaskService, TaskTemplate } from './construction-task.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ValidationService } from '../../../../service/validation.service';
var KtsConstructionTaskComponent = /** @class */ (function (_super) {
    __extends(KtsConstructionTaskComponent, _super);
    function KtsConstructionTaskComponent(router, route, logger, action, message, page, service, alertModalService, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.alertModalService = alertModalService;
        _this.validService = validService;
        _this.toggles = {};
        _this.taskToggles = {};
        _this.taskItems = {};
        _this.constItems = {};
        _this.fieldItems = {};
        _this.seq = 1;
        _this.readonly = false;
        _this.taskMode = "setting" /* setting */;
        _this.fileOptions = {};
        _this.deleteFlg = false;
        _this.step = [];
        _this.referrerType = [];
        _this.partner = [];
        _this.secondaryPartner = [];
        _this.genre = [];
        _this.reportStatus = [];
        _this.dispTask = false;
        return _this;
    }
    KtsConstructionTaskComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.taskMode = jsonpath.value(this.component, '$.params.taskMode') || "setting" /* setting */;
        this.fileOptions = jsonpath.value(this.component, '$.params.fileOptions') || {};
        this.taskTemplate = new TaskTemplate(this.msgSnapshot, this.readonly, this.taskMode, this.fileOptions);
        this.toggles = {};
        for (var i = 1; i <= 5; i++) {
            this.toggles[i] = false;
        }
        this.getType();
        this.setCompRec();
    };
    KtsConstructionTaskComponent.prototype.switchToggle = function (step) {
        this.toggles[step] = !this.toggles[step];
    };
    KtsConstructionTaskComponent.prototype.switchTaskToggle = function (seq) {
        this.taskToggles[seq] = !this.taskToggles[seq];
    };
    KtsConstructionTaskComponent.prototype.getType = function () {
        var _this = this;
        this.DATE_DELIMITER_SLASH = moment().toMomentFormatString(this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.formatDate']);
        this.DATETIME_DELIMITER_SLASH = moment().toMomentFormatString(this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.format']);
        this.service.getType('CONSTRUCTION_STEP').subscribe(function (rec) { return _this.step = rec; });
        this.service.getType('REFERRER_TYPE').subscribe(function (rec) {
            _this.referrerType = rec;
            _this.taskTemplate.upload[2].params.options = _this.referrerType;
        });
        this.service.getGenre().subscribe(function (rec) {
            _this.genre = rec;
            _this.taskTemplate.upload[0].params.options = _this.genre;
        });
        this.service.getType('CONSTRUCTION_REPORT_STATUS').subscribe(function (rec) {
            _this.reportStatus = rec;
            _this.taskTemplate.datetime[0].items[1].params.options = _this.reportStatus;
            _this.taskTemplate.date[0].items[1].params.options = _this.reportStatus;
        });
    };
    KtsConstructionTaskComponent.prototype.onMsg = function (msg) {
        this.taskTemplate = new TaskTemplate(msg, this.readonly, this.taskMode, this.fileOptions);
    };
    KtsConstructionTaskComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsConstructionTaskComponent.prototype.onSubscribe = function (data) {
        var _this = this;
        if (typeof data.project_m_id !== 'undefined') {
            this.service.getPartnerCompany(data.project_m_id).subscribe(function (rec) {
                _this.partner = rec;
                _this.taskTemplate.onsite.cols[0].params.options = _this.partner;
                _this.taskTemplate.onsite_notime.cols[0].params.options = _this.partner;
                _this.taskTemplate.construction.cols[0].params.options = _this.partner;
                _this.secondaryPartner = rec;
                _this.taskTemplate.onsite.cols[1].params.options = _this.secondaryPartner;
                _this.taskTemplate.onsite_notime.cols[1].params.options = _this.secondaryPartner;
                _this.taskTemplate.construction.cols[1].params.options = _this.secondaryPartner;
            });
        }
        if (typeof data.construction_m_id !== 'undefined') {
            this.constructionMId = data.construction_m_id;
            this.constItems = {};
            this.fieldItems = {};
            this.deleteFlg = false;
            this.service.resetVisitComp();
            for (var i = 1; i <= 5; i++) {
                if (this.taskItems[i]) {
                    for (var _i = 0, _a = this.taskItems[i]; _i < _a.length; _i++) {
                        var item = _a[_i];
                        this.setTask(item);
                        this.setField(item);
                    }
                }
            }
            return;
        }
        if (typeof data.items === 'undefined' || !(data.items instanceof Array) || data.items.length === 0) {
            return;
        }
        data = JSOG.parse(JSON.stringify(data));
        this.deleteFlg = false;
        this.service.resetVisitComp();
        // task_u
        if (typeof data.items[0].task_m_id !== 'undefined' && typeof data.items[0].is_complete !== 'undefined') {
            this.constItems = {};
            var items = data.items;
            for (var _b = 0, items_1 = items; _b < items_1.length; _b++) {
                var item = items_1[_b];
                if (item.construction_report && item.construction_report.length > 0) {
                    this.service.sortDatetime(item.construction_report);
                }
                if (item.construction_documents && item.construction_documents.length > 0) {
                    this.service.sortItems(item.construction_documents, 'id');
                    item.documents_genre_id = item.documents_genre_id;
                    item.documents_title = item.construction_documents[0].title;
                    item.documents_type = item.construction_documents[0].type;
                }
                item.$type = "put" /* Put */;
                this.constItems[item.task_m_id] = item;
            }
            for (var i = 1; i <= 5; i++) {
                if (this.taskItems[i]) {
                    for (var _c = 0, _d = this.taskItems[i]; _c < _d.length; _c++) {
                        var item = _d[_c];
                        this.setTask(item);
                    }
                }
            }
        }
        // task_other_field_u
        if (typeof data.items[0].task_other_field_m_id !== 'undefined') {
            this.fieldItems = {};
            var items = data.items;
            for (var _e = 0, items_2 = items; _e < items_2.length; _e++) {
                var item = items_2[_e];
                item.$type = "put" /* Put */;
                this.fieldItems[item.task_other_field_m_id] = item;
            }
            for (var i = 1; i <= 5; i++) {
                if (this.taskItems[i]) {
                    for (var _f = 0, _g = this.taskItems[i]; _f < _g.length; _f++) {
                        var item = _g[_f];
                        this.setField(item);
                    }
                }
            }
        }
        // task_m
        if (typeof data.items[0].project_m_id !== 'undefined' && typeof data.items[0].template_type !== 'undefined') {
            this.taskItems = {};
            var items = data.items;
            this.seq = 1;
            for (var i = 1; i <= 5; i++) {
                this.taskItems[i] = [];
            }
            for (var _h = 0, items_3 = items; _h < items_3.length; _h++) {
                var item = items_3[_h];
                item.$seq = this.seq++;
                if (item.task_other_field_m && item.task_other_field_m.length > 0) {
                    this.service.sortItems(item.task_other_field_m);
                }
                this.taskItems[item.step].push(item);
                this.taskToggles[item.$seq] = false;
                this.setTask(item);
                this.setField(item);
            }
        }
        this.setCompRec();
    };
    KtsConstructionTaskComponent.prototype.setTask = function (item) {
        if (typeof this.constItems[item.id] === 'undefined') {
            this.constItems[item.id] = Object.assign(new ConstructionTask(), {
                task_m_id: item.id,
                construction_m_id: this.constructionMId
            });
        }
        if (item.template_type === "onsite_notime" /* onsite_notime */) {
            for (var _i = 0, _a = this.constItems[item.id].construction_report; _i < _a.length; _i++) {
                var report = _a[_i];
                var dateKeys = ['visiting_scheduled_date', 'leaving_scheduled_date'];
                for (var _b = 0, dateKeys_1 = dateKeys; _b < dateKeys_1.length; _b++) {
                    var key = dateKeys_1[_b];
                    if (report[key]) {
                        report[key] = moment(report[key], this.DATETIME_DELIMITER_SLASH).format(this.DATE_DELIMITER_SLASH);
                    }
                }
            }
        }
    };
    KtsConstructionTaskComponent.prototype.setField = function (item) {
        for (var _i = 0, _a = item.task_other_field_m; _i < _a.length; _i++) {
            var field = _a[_i];
            if (typeof this.fieldItems[field.id] === 'undefined') {
                this.fieldItems[field.id] = Object.assign(new ConstructionTaskOtherField(), {
                    task_other_field_m_id: field.id,
                    construction_m_id: this.constructionMId
                });
            }
        }
    };
    KtsConstructionTaskComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    KtsConstructionTaskComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.getType();
        }
        else if (e === this.componentName + '#dispTask') {
            this.dispTask = true;
        }
        else if (e === this.componentName + '#button') {
            // 必須チェック
            var event_1 = this.action.getEvent('taskSave');
            if (typeof event_1.action === 'undefined') {
                return;
            }
            var valid = this.validService.validation('submit', event_1, this.action.getCompRec(), this.msgSnapshot);
            if (!valid.validation) {
                return;
            }
            // 確認のアラートモーダルを表示
            var msg = this.deleteFlg ? this.msgSnapshot['au.COMPONENT.KtsConstructionTaskComponent.Modal.save.confirmIncludingDelete'] : this.msgSnapshot['au.COMPONENT.KtsConstructionTaskComponent.Modal.save.confirm'];
            this.alertModalService.open({
                message: msg,
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#save#ok',
                        caption: this.msgSnapshot['Modal.button.ok']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#save#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e === this.componentName + '#save#ok') {
            // タスク保存
            this.action.firstAction('taskSave');
        }
    };
    KtsConstructionTaskComponent.prototype.onEvent = function (e1, e2, r) {
    };
    KtsConstructionTaskComponent.prototype.onChange = function (e, key) {
        this.constItems[key][e.key] = e.val;
        if (typeof e.delFlg !== 'undefined' && e.delFlg === true) {
            this.deleteFlg = true;
        }
        this.setCompRec();
    };
    KtsConstructionTaskComponent.prototype.onChangeMultiFile = function (e, key) {
        this.constItems[key].construction_documents = e['construction_documents'];
        this.setCompRec();
    };
    KtsConstructionTaskComponent.prototype.onChangeField = function (e, key) {
        this.fieldItems[key][e.key] = e.val;
        this.setCompRec();
    };
    KtsConstructionTaskComponent.prototype.setCompRec = function () {
        var constData = [];
        var constItems = JSOG.parse(JSON.stringify(this.constItems));
        var documentsData = [];
        var documentsDeleteData = [];
        for (var i = 1; i <= 5; i++) {
            if (!this.taskItems[i]) {
                continue;
            }
            for (var _i = 0, _a = this.taskItems[i]; _i < _a.length; _i++) {
                var item = _a[_i];
                var necessity = (constItems[item.id].necessity.toString() === 'false' ? false : true);
                if (item.template_type === "file" /* file */) {
                    for (var i_1 = constItems[item.id].construction_documents.length - 1; i_1 >= 0; i_1--) {
                        var doc = constItems[item.id].construction_documents[i_1];
                        if (!necessity) {
                            if (typeof doc.id !== 'undefined') {
                                doc['$type'] = "delete" /* Delete */;
                            }
                            else {
                                constItems[item.id].construction_documents.splice(i_1, 1);
                                continue;
                            }
                        }
                        else {
                            doc.construction_m_id = this.constructionMId;
                            doc.task_u_id = constItems[item.id].id;
                            doc['task_m_id'] = item.id;
                            doc.documents_genre_id = constItems[item.id].documents_genre_id;
                            doc.title = constItems[item.id].documents_title;
                            doc.type = constItems[item.id].documents_type;
                        }
                        if (doc['$type'] === "delete" /* Delete */) {
                            documentsDeleteData.push(doc);
                        }
                        else {
                            documentsData.push(doc);
                        }
                    }
                }
                delete constItems[item.id].construction_documents;
                if (item.template_type !== "onsite" /* onsite */ && item.template_type !== "onsite_notime" /* onsite_notime */ && item.template_type !== "construction" /* construction */) {
                    constItems[item.id].construction_report = [];
                    constItems[item.id].partner_company_m_id = null;
                    constItems[item.id].secondary_partner_company_m_id = null;
                }
                else {
                    for (var _b = 0, _c = constItems[item.id].construction_report; _b < _c.length; _b++) {
                        var report = _c[_b];
                        if (report.status === '') {
                            report.status = null;
                        }
                        if (item.template_type === "onsite_notime" /* onsite_notime */) {
                            var dateKeys = ['visiting_scheduled_date', 'leaving_scheduled_date'];
                            for (var _d = 0, dateKeys_2 = dateKeys; _d < dateKeys_2.length; _d++) {
                                var key = dateKeys_2[_d];
                                if (report[key]) {
                                    report[key] = moment(report[key], this.DATE_DELIMITER_SLASH).format(this.DATETIME_DELIMITER_SLASH);
                                }
                            }
                        }
                    }
                }
                constData.push(constItems[item.id]);
            }
        }
        var fieldData = [];
        var fieldItems = JSOG.parse(JSON.stringify(this.fieldItems));
        for (var _e = 0, _f = Object.keys(fieldItems); _e < _f.length; _e++) {
            var key = _f[_e];
            if (!fieldItems[key].value) {
                if (typeof fieldItems[key].id === 'undefined') {
                    continue;
                }
                else {
                    // 「task_other_field_u_composite_key_1」の 制約に引っかかる為、task_outline_field_uは削除しない
                    // fieldItems[key].$type = RequestMethod.Delete;
                }
            }
            fieldData.push(fieldItems[key]);
        }
        this.action.setCompRec(this.componentName, { items: constData });
        this.action.setCompRec(this.componentName + '#documents', { items: documentsDeleteData.concat(documentsData) });
        this.action.setCompRec(this.componentName + '#field', { items: fieldData });
    };
    KtsConstructionTaskComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-construction-task',
                    template: "<div *ngIf=\"!dispTask\" class=\"row\" id=\"{{ componentName + 'DispTask' }}\">\n  <div class=\"col-sm-12\">\n    <btn [componentName]=\"componentName + '#dispTask'\"\n         [component]=\"{\n           params: {\n             buttons: [{\n               type: 'button',\n               event: componentName + '#dispTask',\n               caption: (msg | async)['au.COMPONENTS.button.task_display']\n             }]\n           }\n         }\"></btn>\n  </div>\n</div>\n<form *ngIf=\"dispTask\" id=\"{{ componentName }}\">\n  <div *ngFor=\"let st of step; let stepIndex = index;\" class=\"row\" [class.-mb-1]=\"stepIndex < step.length - 1\">\n    <div class=\"col-sm-12\">\n      <div class=\"filter\">\n        <p class=\"filter_trigger\">\n          <span [class.open]=\"toggles[st.code]\" (click)=\"switchToggle(st.code)\">STEP{{ st.code }}: {{ st.display }}</span>\n        </p>\n        <div *ngFor=\"let taskItem of taskItems[st.code]; let index = index;\" class=\"filter -mx-2 -my-1\" [style.display]=\"toggles[st.code] ? 'block': 'none'\">\n          <p class=\"filter_trigger\">\n            <span [class.open]=\"taskToggles[taskItem.$seq]\" (click)=\"switchTaskToggle(taskItem.$seq)\"><!--\n              --><span *ngIf=\"constItems[taskItem.id].is_complete\" style=\"color: #2db2e6; font-weight: 800;\">{{ (msg | async)['au.COMPONENTS.label.task_completion'] }}</span><!--\n              --><span *ngIf=\"!constItems[taskItem.id].is_complete\" style=\"color: red; font-weight: 800;\">{{ (msg | async)['au.COMPONENTS.label.task_incomplete'] }}</span>: {{ taskItem.name }}\n            </span>\n          </p>\n          <div class=\"filter_property_toggle -m-1 -mb-2\" [style.display]=\"taskToggles[taskItem.$seq] ? 'block': 'none'\">\n            <ul class=\"form form-campaign\">\n              <li class=\"stageFlowPane\">\n                <div class=\"stageFlowPane_border\">\n                  <div *ngIf=\"taskTemplate[taskItem.template_type]?.necessity\" class=\"row -m-1\">\n                    <div class=\"col-sm-12\">\n                      <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"taskTemplate.necessity\" [val]=\"constItems[taskItem.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, taskItem.id)\"></column>\n                    </div>\n                  </div>\n                  <div *ngIf=\"taskTemplate[taskItem.template_type]?.datetime\" class=\"row -m-1\" [class.-mt-2]=\"taskTemplate[taskItem.template_type]?.necessity\">\n                    <div class=\"col-sm-12\">\n                      <kts-construction-task-visit\n                          *ngIf=\"reportStatus.length > 0\"\n                          [componentName]=\"componentName + '#datetime' + taskItem.$seq\"\n                          [component]=\"{name: componentName + '#datetime' + taskItem.$seq, params: {primaryKey: 'id'}}\"\n                          [visitCols]=\"taskTemplate.datetime\"\n                          [vals]=\"constItems[taskItem.id]\"\n                          (changeField)=\"onChange($event, taskItem.id)\"></kts-construction-task-visit>\n                    </div>\n                  </div>\n                  <div *ngIf=\"taskTemplate[taskItem.template_type]?.date\" class=\"row -m-1\" [class.-mt-2]=\"taskTemplate[taskItem.template_type]?.necessity || taskTemplate[taskItem.template_type]?.datetime\">\n                    <div class=\"col-sm-12\">\n                      <kts-construction-task-visit\n                          *ngIf=\"reportStatus.length > 0\"\n                          [componentName]=\"componentName + '#date' + taskItem.$seq\"\n                          [component]=\"{name: componentName + '#date' + taskItem.$seq, params: {primaryKey: 'id'}}\"\n                          [visitCols]=\"taskTemplate.date\"\n                          [vals]=\"constItems[taskItem.id]\"\n                          (changeField)=\"onChange($event, taskItem.id)\"></kts-construction-task-visit>\n                    </div>\n                  </div>\n                  <div *ngFor=\"let col of taskTemplate[taskItem.template_type]?.cols; let colIndex = index;\" class=\"row -m-1\" [class.-mt-2]=\"colIndex > 0 || taskTemplate[taskItem.template_type]?.necessity || taskTemplate[taskItem.template_type]?.datetime || taskTemplate[taskItem.template_type]?.date\">\n                    <div class=\"col-sm-12\">\n                      <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"col\" [val]=\"constItems[taskItem.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, taskItem.id)\"></column>\n                    </div>\n                  </div>\n                  <ng-template [ngIf]=\"taskTemplate[taskItem.template_type].upload\">\n                    <div *ngFor=\"let col of taskTemplate.upload\" class=\"row -m-1 -mt-2\">\n                      <div class=\"col-sm-12\">\n                        <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"col\" [val]=\"constItems[taskItem.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, taskItem.id)\"></column>\n                      </div>\n                    </div>\n                    <div class=\"row -m-1 -mt-2\">\n                      <div class=\"col-sm-12\">\n                        <kts-multi-upload\n                            [child]=\"true\"\n                            [componentName]=\"componentName + '#file' + taskItem.$seq\"\n                            [component]=\"{name: componentName + '#file' + taskItem.$seq, params: {primaryKey: 'id', fileKey: 'file', fileOptions: fileOptions}}\"\n                            [parentCols]=\"taskTemplate.multiUpload\"\n                            [parentItems]=\"constItems[taskItem.id]\"\n                            (changeItems)=\"onChangeMultiFile($event, taskItem.id)\"></kts-multi-upload>\n                      </div>\n                    </div>\n                    <div class=\"row -m-1 -mt-2\">\n                      <div class=\"col-sm-12\">\n                        <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"taskTemplate.uploadConfirm\" [val]=\"constItems[taskItem.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, taskItem.id)\"></column>\n                      </div>\n                    </div>\n                  </ng-template>\n                  <div *ngFor=\"let field of taskItem.task_other_field_m\" class=\"row -m-1 -mt-2\">\n                    <div class=\"col-sm-12\">\n                      <column [key]=\"'form'\" [componentName]=\"componentName + '#field'\" [index]=\"taskItem.$seq\" [col]=\"{\n                        label: field.name,\n                        key: 'value',\n                        controlType: 'text',\n                        readonly: readonly,\n                        params: {formClass: {width: '100per'}}\n                      }\" [val]=\"fieldItems[field.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeField($event, field.id)\"></column>\n                    </div>\n                  </div>\n                  <p class=\"-m-1 -mt-2\">{{ taskTemplate[taskItem.template_type]?.note }}</p>\n                </div>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row -mt-1\">\n    <div class=\"col-sm-12\">\n      <btn [componentName]=\"componentName + '#button'\"\n           [component]=\"{\n             params: {\n               buttons: [{\n                 type: 'button',\n                 event: componentName + '#button',\n                 caption: (msg | async)['Button_save']\n               }]\n             }\n           }\"></btn>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsConstructionTaskComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsConstructionTaskService },
        { type: AlertModalService },
        { type: ValidationService }
    ]; };
    return KtsConstructionTaskComponent;
}(ContentBaseComponent));
export { KtsConstructionTaskComponent };
//# sourceMappingURL=construction-task.component.js.map